import React from 'react';
import { TooltipContainer } from './styles';
import PropTypes from 'prop-types';

export default function TooltipComponent(props) {
  return (
    <>
      <TooltipContainer
        className='contribution'
        placement={props.placement}
        title={props.title}
        autoAdjustOverflow={false}
      >
        {props.children}
      </TooltipContainer>
    </>
  );
}

TooltipComponent.propTypes = {
  title: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
}